export function isExternalUrl(url: string): boolean {
  try {
    const urlObject = new URL(url);
    return urlObject.hostname !== location.hostname;
  } catch (_error) {
    // The URL constructor throws a TypeError for relative URLs (e.g., "/insights-reports").
    // Consider these as internal.
    return false;
  }
}
